// use this one
import $ from 'jquery';
import { debounce } from 'buyside/util/lodashAlt';

class Autocomplete {

  constructor() {
    this.selectItem = this.selectItem.bind(this);
  }

  setup(input) {
    let noLoadingKeyCodes = [37, 38, 39, 40, 9, 13, 16, 17, 18, 27]; // up, left, down, right, tab, enter, shift, ctrl, alt, esc, cmd/left-window
    let autocompleteSelected;
    this.$input = $(input);
    this.autocompleteType = this.$input.data('autocomplete') || '';
    this.wrapper = this.$input.closest('[data-autocomplete-wrapper]');
    this.triggerChange = this.$input.data('autocompleteTriggerChange');

    // Hidden fields can be referenced directly via the "data-target" attribute and specifying the ID of the hidden field, but if you need
    // multiple cloned instances of the same autocomplete fieldsets, then you can't use IDs. Instead, you'll have to wrap each set of fields
    // with in a "data-autocomplete-wrapper" element with "data-autocomplete-hidden" attached to the hidden field.

    let hiddenFieldId = this.$input.data('target');
    this.$hiddenField = hiddenFieldId ? $(hiddenFieldId) : this.wrapper.find('[data-autocomplete-hidden]');

    this.nextInput = this.$input.data('autocomplete-advance') === false ? this.$input : this.getNextInput(this.$input);
    let previousVal = '';

    this.route = (() => { switch (this.autocompleteType) {
      case 'omni': return 'omni';
      case 'security': return 'security';
      default: return '';
    } })();

    // Create the results div
    this.$resultsDiv = this.$input.after('<div class="autocomplete-resultsContainer"></div>').next();

    // One-time event to set the resultsDiv width, since the element
    // doesn't always have a width when the code is initialized
    this.$input.one('focus', () => {
      return this.$resultsDiv.css('minWidth', this.$input.css('width'));
    });

    // Attach events...
    this.setKeyboardEvents();
    this.$input.on('keyup', event => {
      let inputVal = this.$input.val();
      if (inputVal === '') {
        if (this.$hiddenField.length) { this.$hiddenField.val(null); }
        previousVal = this.$input.val();
        return this.$resultsDiv.removeClass('is-active');
      }

      let keycode = event.keycode || event.which;

      // Make the server request only if this is not in the list of reserved keys
      // or the content of the input hasn't changed
      if ((noLoadingKeyCodes.indexOf(keycode) < 0) && (this.$input.val() !== previousVal)) {
        if (this.$hiddenField.length) { this.$hiddenField.val(null); }
        this.$resultsDiv.addClass('is-active');
        this.$resultsDiv.html('<span class="autocomplete-loading"> <svg class="loadingIcon--small" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="loadingIconPath" fill="none" stroke-width="9" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>Loading...</span>').show();
        this.makeRequest();
        previousVal = this.$input.val();
        // Close results if user clicks off the results div
        return $('html').one('click', event => {
          return this.$resultsDiv.removeClass('is-active');
        }
        );
      } else if (keycode === 27) { // esc
        return this.closeResultsDiv();
      }
    }
    );

    // Prevent autocompletes from getting re-initalized
    this.$input.data('autocomplete-initialized', true);

    // Mark current hover li as selected. It will really be seleted on blur (happening on click or enter)
    this.$resultsDiv.on("mouseenter", "li", event => {
      this.$resultsDiv.find('li').removeClass('selected');
      let $target = $(event.target);
      if ($target.is('li')) {
        return $target.addClass("selected");
      }
    }
    );

    this.$resultsDiv.on("click", 'li', this.selectItem);

    this.$input.on('selected.autocomplete', () => autocompleteSelected = true);

    // Check if the user has actually selected a ticker from the menu and
    // trigger the notSelected event if they haven't.
    return this.$input.on("blur", () => {
      return window.setTimeout(() => {
        if (autocompleteSelected) {
          this.lastAutocompleteValue = this.$input.val();
          return autocompleteSelected = false;
        } else if (this.lastAutocompleteValue === this.$input.val()) {
          return autocompleteSelected = false;
        } else {
          return this.$input.trigger('notSelected.autocomplete');
        }
      }
      , 500);
    }
    );
  }



  makeRequest() {
    if (!this.runRequest) {
      this.assetClass = this.$input.data('asset-class');

      let request = () => {
        return $.ajax({
          url: `/pro/autocomplete/${this.route}`,
          data: {
            q: this.$input.val(),
            asset_class: this.assetClass || null,
            type: this.autocompleteType
          },
          dataType: 'html',
          success: html_response => {
            // console.log(html_response)
            this.$resultsDiv.html(html_response);
            // Auto-highlight the first result unless this is a new item
            let $firstResult = this.$resultsDiv.find("li").first();
            if ($firstResult.attr("id") !== "new-autocomplete-item") { $firstResult.addClass("selected"); }

            // Remove "Add New Item" if disallowed
            if (this.$input.data('autocomplete-noadd')) { this.$resultsDiv.find('li.new-autocomplete-item').remove(); }

            // If there is *only one* exact matching ticker then show it and hide the ticker input fields
            let exactMatch = this.$resultsDiv.find(".exact-match");
            if (exactMatch.length === 1) {
              if ((this.$resultsDiv.find("li:not(.exact-match)").length === 0) && (exactMatch.data("ticker") === this.$input.val())) {
                this.$resultsDiv.hide();
                if (this.triggerChange) { this.$input.trigger("change", $target); }
                return this.$input.trigger("selected.autocomplete", $target);
              }
            }
          }
        });
      };

      this.runRequest = debounce(request, 500);
    }
    return this.runRequest();
  }

  closeResultsDiv() {
    this.$resultsDiv.removeClass('is-active');
    return $('html').off('click');
  }

  selectItem(event) {
    event.preventDefault();
    event.stopPropagation();

    let $target = $(event.target);

    if (this.autocompleteType === 'omni') {
      let route = $target.data('route');
      if (!route) { route = $target.parents("[data-route]").data('route'); }
      if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? `:${window.location.port}` : '');
    }
      return window.location = window.location.origin + route;
    } else {
      let value = $target.data('value') || this.$input.val();
      this.$input.val(value);
      if (this.$hiddenField.length) { this.$hiddenField.val($target.data('id')); }
      this.$input.trigger('input'); // for angular ngModel
      this.$input.trigger("selected.autocomplete", $target);

      //###TODO HACKED up temp solution
      // callback = angular.element($(".search-group")).scope().getAssetData
      // callback({otherId: $target.data("id")}) if callback

      if (this.triggerChange) { this.$input.trigger("change", $target); }
      this.$resultsDiv.removeClass('is-active');
      if (this.nextInput !== this.$input) { return this.nextInput.focus(); }
    }
  }

  setKeyboardEvents() {

    let enterKey = event => {
      event.preventDefault();
      return this.$resultsDiv.find("li.selected").first().trigger('click');
    };

    let nextItem = direction => {
      let selectedItem = this.$resultsDiv.find("li.selected").first();
      selectedItem.removeClass("selected");
      selectedItem.getNextItem = () => {
        // Highlight the next item if it's in the same <ul> group otherwise jump to the previous group
        // and select the first/last item there.
        if (direction === 'down') {
          if (selectedItem.length) {
            return selectedItem.next().length ? selectedItem.next() : selectedItem.parent().nextAll('ul').first().find('li').first();
          } else {
            return this.$resultsDiv.find('li').first();
          }
        } else if (direction === 'up') {
          return selectedItem.prev().length ? selectedItem.prev() : selectedItem.parent().prevAll('ul').first().find('li').last();
        }
      };
      return selectedItem.getNextItem().addClass("selected");
    };

    let tabKey = () => {
      this.$resultsDiv.removeClass('is-active');
      return this.$resultsDiv.find("li.selected").first().trigger('click');
    };

    return this.$input.on('keydown', event => {
      let keycode = event.keyCode || event.which;
      switch (keycode) {
        case 13: return enterKey(event);
        case 38: return nextItem('up');
        case 40: return nextItem('down');
        case 9:  return tabKey();
      }
    }
    );
  }

  getNextInput(input) {
    let formInputs = $(input).closest('form').find(':input').not('[disabled], [type=hidden], button');
    return formInputs.eq(formInputs.index(input) + 1);
  }
}

// jQuery plugin for attaching autocompletes on the fly
$.fn.handleAutocomplete = function() {
  if (!$(this).data('autocomplete-initialized')) { return new Autocomplete().setup(this); }
};

$(function() {
  return $('[data-autocomplete]').each(function(index, field) {
    if (!$(field).data('autocomplete-initialized')) { return new Autocomplete().setup(field); }
  });
});
